import React from 'react';
import {
    getProspectForms,
} from 'api/prospect';
import { getGPProspectForms } from 'api/group';
import { ProspectForm } from 'types/common';


const useProspectForms = (id: number, isPracticeView = false): [ProspectForm[], boolean, () => void] => {
    const [data, setData] = React.useState<ProspectForm[]>([]);
    const loading = React.useRef(false);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = isPracticeView
                ? await getGPProspectForms(id)
                : await getProspectForms(id);

            if (!result.error) {
                const _data = result?.data?.data || [];
                setData(_data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current && id) {
            fetchData();
        }
    }, [id]);

    return [data, loading.current, fetchData];
};

export default useProspectForms;
